import React, { useState, Fragment } from 'react';
import {
  Container,
  StartupData,
  Content,
  BackgroundContentImage,
  BackgroundContentColor
} from './styles';
import PropTypes from 'prop-types';
import Image from '../Image';

const Startup = ({
  src,
  alt,
  data,
  workplace,
  technologies,
  backgroundImage,
  message
}) => {
  const [startupShowered, expandedStartup] = useState(false);
  const [meShowed, expandedMe] = useState(false);

  const { startup, me } = message;
  return (
    <Container>
      <StartupData>
        <Image src={src} alt={alt} />
        <div>
          <span>Date:</span> <p>{data}</p>
        </div>
        <div>
          <span>Technologies:</span> <p>{technologies}</p>
        </div>
        <div>
          <span>WorkPlace:</span> <p>{workplace}</p>
        </div>
      </StartupData>

      <Content style={{backgroundImage: `url(${backgroundImage})`}}>
        { startup &&
          <div>
            <span>{startup.title}</span>
            { startupShowered && startup.expandInfo ? (
                <Fragment>
                  {startup.info.map(item => <p key={item.id}>{item.paragraph}</p> )}
                  <p onClick={() => expandedStartup(false)}>{startup.expandedInfo}</p>
                </Fragment>
                ) : (
                <Fragment>
                  { startup.info.slice(0, 1).map(item => (
                      <p key={item.id}>{item.paragraph}</p>
                  ))}
                  <p onClick={() => expandedStartup(true)}>{startup.expandInfo}</p>
                </Fragment>
            )}
          </div>
        }

        { me &&
          <div>
            <span>{me.title}</span>
            { meShowed && me.expandInfo ? (
                <Fragment>
                  { me.info.map(item => <p key={item.id}>{item.paragraph}</p> )}
                  <p onClick={() => expandedMe(false)}>{me.expandedInfo}</p>
                </Fragment>
              ) : (
                <Fragment>
                  { me.info.slice(0, 1).map(item => (
                      <p key={item.id}>{item.paragraph}</p>
                  ))}
                  <p onClick={() => expandedMe(true)}>{me.expandInfo}</p>
                </Fragment>
            )}
          </div>
        }

        <BackgroundContentImage className='bg-ContentImage' />
        <BackgroundContentColor />
      </Content>
    </Container>
  );
};

Startup.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  technologies: PropTypes.string,
  data: PropTypes.string,
  workplace: PropTypes.string,
  backgroundImage: PropTypes.string,
  message: PropTypes.object,
};

export default Startup;
